import { ChevronLeft, ChevronRight, MapPin, Check, ArrowRight } from "lucide-react";
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const projectDetailData = {
  "floors": { name: "Gillco Floors", type: "Independent Floors", location: "Sector 127, Mohali", status: "Delivered", price: "Sold Out", description: "Experience the comfort of independent living with thoughtfully designed Ground + 2, 3BHK Floors that offer privacy and space.", features: ["3BHK Independent Floors", "Part of Gated Township", "Premium Interiors", "Modular Kitchen", "Community Living", "24x7 Security"], specs: { bhk: "3 BHK Floors", location: "Sector 127, Mohali", area: "1450 sq.ft." }, images: ["/assets/floor/floor.png"] },
  "towers": { name: "Gillco Towers", type: "High Rise Apartments", location: "Sector 127, Mohali", status: "Delivered", price: "Sold Out", description: "Gillco Towers brought together spacious living and contemporary design through thoughtfully crafted 3 & 4 BHK residences.", features: ["3 & 4 BHK Apartments", "Part of Gated Township", "Premium Interiors", "Modular Kitchen", "Community Living", "24x7 Security"], specs: { bhk: "3 & 4 BHK", location: "Sector 127, Mohali", area: "1,650 – 2,550 sq.ft." }, images: ["/assets/tower/tower.jpg"] },
  "heights": { name: "Gillco Heights", type: "High Rise Apartments", location: "Sector 127, Mohali", status: "Delivered", price: "Sold Out", description: "Envisioned as a thoughtfully planned residential community offering spacious 2 & 3 BHK apartments designed for modern family living.", features: ["2 & 3 BHK Apartments", "Part of Gated Township", "Premium Interiors", "Modular Kitchen", "Community Living", "24x7 Security"], specs: { units: "385", bhk: "2 & 3 BHK", location: "Sector 127, Mohali", area: "1,100 – 1,600 sq.ft." }, images: ["/assets/height/height.jpg"] },
  "parkhills": { name: "Gillco Parkhills", type: "Premium Residential", location: "Airport Road, Mohali", status: "Delivered", price: "Sold Out", description: "Mohali's finest and most sought after S + 19-story high Premium 2, 3, and 4 BHK apartments on Airport Road, Mohali.", features: ["19 Stories High", "2, 3, 4 BHK Options", "40+ Amenities", "Premium Clubhouse", "Swimming Pool", "Landscaped Gardens"], specs: { size: "10 Acres", units: "600+", bhk: "2, 3, 4 BHK", area: "1075 - 2350 sq.ft." }, images: ["/assets/parkhill/1.png", "/assets/parkhill/2.png", "/assets/parkhill/3.png", "/assets/parkhill/4.png", "/assets/parkhill/5.png"] },
  "meraqui": { name: "Gillco Meraqui", type: "Ultra Luxe Residential", location: "Sector 126, Mohali", status: "New Launch", price: "On Request", description: "An upcoming residential masterpiece in Sector 126, Mohali featuring 444 exquisitely designed 3 & 4 BHK luxury residences.", features: ["Elite Clubhouse", "Mini Private Theatre", "Infinity Pool", "Multi Sports Court", "Landscaped Greens", "Jogging Track"], specs: { size: "12 Acres", towers: "6", bhk: "3-4 BHK", units: "444" }, images: ["/assets/meraqui/1.jpg", "/assets/meraqui/2.jpg", "/assets/meraqui/3.jpg", "/assets/meraqui/4.jpg", "/assets/meraqui/5.jpg", "/assets/meraqui/6.jpg", "/assets/meraqui/7.jpg"] },
  "palms": { name: "Gillco Palms", type: "Residential", location: "Kharar-Landran Road, Mohali", status: "Delivered", price: "Sold Out", description: "Nestled on Kharar-Landran Road, Mohali featuring premium 2 BHK and 3 BHK living spaces designed to blend comfort and elegance.", features: ["Spacious Apartments", "24 Hr Water Supply", "24 Hr Security & Surveillance", "24 Hr In-house Ambulance", "100% Harvesting for Horticulture", "3.5 km From Chandigarh"], specs: { bhk: "2/3 BHK Floors", units: "100+", location: "Sector 115, Kharar" }, images: ["/assets/palm/1.png", "/assets/palm/2.png", "/assets/palm/3.png", "/assets/palm/main-palm-image.png"] },
  "industrial-park": { name: "Gillco Industrial Park", type: "Industrial", location: "Airport Road, Mohali", status: "Ongoing", price: "On Request", description: "200 acres of development on Airport Road, Mohali, Gillco Industrial Park is a game-changer in the business and industrial landscape.", features: ["200 Acres", "IT City Mohali, Airport Road, Mohali", "Industrial Plots", "Showrooms", "Modern Infrastructure", "Business-Friendly"], specs: { size: "200 Acres", type: "Industrial", location: "IT City Mohali" }, images: ["/assets/industrialPark/1.png", "/assets/industrialPark/2.png", "/assets/industrialPark/3.png", "/assets/industrialPark/4.png"] },
  "villas": { name: "Gillco Villas", type: "Independent Villas", location: "Gillco Valley", status: "Delivered", price: "Sold Out", description: "Artistically designed 200 Duplex Villas in Gillco Valley for those who value independent lifestyle in community environment.", features: ["Duplex Villas", "Landscaped Greens", "Premium Interiors", "Community Living", "24x7 Security", "Part of Gated Township"], specs: { units: "200", type: "Duplex Villas", bhk: "3-4 BHK" }, images: ["/assets/villa/gillco_villas.png"] },
};

export const ProjectDetailPage = () => {
  const { projectId } = useParams();
  const [ci, setCi] = useState(0);
  const [utm_source, setUtmSource] = useState("google");
  const [formError, setFormError] = useState({});
  const [sending, setSending] = useState(false);
 const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const project = projectDetailData[projectId];
   const [mailURL ,setMailURL]=useState("");
    const currentDate = new Date()
    .toLocaleDateString("en-GB")
    .replace(/-/g, "/");
      const generateCaptcha = () => {
        return Math.random()
          .toString(36)
          .substring(2, 8);
      };
    
      const [captchaText, setCaptchaText] = useState(generateCaptcha());
      const [captchaInput, setCaptchaInput] = useState("");

  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  useEffect(() => {
    document.body.style.overflow = showEnquiryModal ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showEnquiryModal]);

    const [data, setData] = useState({
    name: "",
    message: "",
    email: "",
    city:"",
    phoneNumber: "",
    date: currentDate,
    ipAddress: "",
    subject:"Enquiry",
    leadSource: "google",
    project: "",
});
 useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const utm_source =
      urlParams.get("utm_source") || "google";

    setUtmSource(utm_source);

  setData((prev) => ({
      ...prev,
      leadSource: utm_source,
    }));
  },[]);

      useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((ipData) => {
        setData((prev) => ({
          ...prev,
          ipAddress: ipData.ip,
        }));
      })
      .catch(() => {
        console.log("Failed to fetch IP");
      });
  }, []);

    const validate = (values) => {
    const errors = {};
    if (captchaInput !== captchaText) {
      errors.captcha = "Invalid captcha";
    }
    if (!values.name)
      errors.name = "Name is required";

    if (!values.email) {
      errors.email = "Email is required";
    } else {
      const emailRegex =
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (!emailRegex.test(values.email)) {
        errors.email = "Invalid Email";
      }
    }

    if (!values.phoneNumber) {
      errors.phoneNumber = "Phone is required";
    }

    return errors;
  };
    useEffect(() => {
const endpoint = process.env.REACT_APP_ENDPOINT_MAIL_URL;

const fullURL = `${window.location.origin}${endpoint}${
process.env.REACT_APP_ENQUIRY_TOKEN
? `${endpoint.includes("?") ? "&" : "?"}token=${encodeURIComponent(
process.env.REACT_APP_ENQUIRY_TOKEN)}`
: ""
}`;setMailURL(fullURL);
}, []);

   
  // mail-functionality

  const sendMail = async (e) => {
  e.preventDefault();

  if (!mailURL) return;

  const errors = validate(data);
  setFormError(errors);

  if (Object.keys(errors).length > 0) return;
    setSending(true);


  try {
   

    const response = await fetch(mailURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Request failed");
    }

    setSubmitted(true);

    setData({
      name: "",
      message: "",
      email: "",
      phoneNumber: "",
      date: currentDate,
      ipAddress: "",
      subject: "",
      leadSource: utm_source,
      project: "",
    });

    setTimeout(() => {
      navigate("/thankyou");
    }, 1000);
  } catch (error) {
    alert("Something went wrong. Please try again.");
  } finally {
    setSending(false);
  }
};

  // const [data, setdata] = useState({
  //   name: "",
  //   email: "",
  //   city: "",
  //   project: project?.name || "",
  //   message: "",
  // });
  useEffect(() => {
    setData((prev) => ({
      ...prev,
      project: project?.name || "",
    }));
  }, [project]);

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
      leadSource: utm_source,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(data);



    setShowEnquiryModal(false);
  };
  if (!project) return (<div className="min-h-screen flex items-center justify-center"><div className="text-center"><h1 className="text-4xl text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Project Not Found</h1><Link to={`/projects`} className="text-[#0A4F3B]">Back to Projects</Link></div></div>);
  const imgs = project.images;
  return (
    <>
      <div data-testid="v13-project-detail-page">
        <div className="relative h-[70vh] min-h-[500px]">
          <img src={imgs[ci]} alt={project.name} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-4">
            <button onClick={() => setCi(ci === 0 ? imgs.length - 1 : ci - 1)} className="w-12 h-12 bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/40 transition-colors" data-testid="gallery-prev"><ChevronLeft className="text-white" /></button>
            <button onClick={() => setCi(ci === imgs.length - 1 ? 0 : ci + 1)} className="w-12 h-12 bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/40 transition-colors" data-testid="gallery-next"><ChevronRight className="text-white" /></button>
          </div>
          <div className="absolute bottom-8 right-8 text-white font-body text-sm">{ci + 1} / {imgs.length}</div>
          <Link to={`/projects`} className="absolute top-8 left-8 flex items-center gap-2 text-white font-body text-sm hover:gap-3 transition-all"><ChevronLeft size={16} /> Back to Projects</Link>
        </div>
        <section className="py-20 lg:py-32 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid lg:grid-cols-3 gap-16">
              <div className="lg:col-span-2">
                <div className="flex items-center gap-4 mb-4"><span className="bg-[#0A4F3B] text-white px-4 py-2 text-xs tracking-wider uppercase">{project.status}</span><span className="font-body text-sm text-[#4A4A4A] uppercase tracking-wider">{project.type}</span></div>
                <h1 className="text-4xl sm:text-5xl text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{project.name}</h1>
                <div className="flex items-center gap-2 text-[#4A4A4A] mb-8"><MapPin size={18} /><span className="font-body">{project.location}</span></div>
                <div className="w-16 h-0.5 bg-[#C4A265] mb-8" />
                <p className="font-body text-lg text-[#4A4A4A] leading-relaxed mb-12" style={{ whiteSpace: "pre-line" }}>{project.description}</p>
                <h2 className="text-2xl text-[#0A0A0A] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Key Features</h2>
                <div className="grid sm:grid-cols-2 gap-4 mb-12">{project.features.map((f, i) => (<div key={i} className="flex items-center gap-3"><div className="w-6 h-6 rounded-full bg-[#C4A265]/10 flex items-center justify-center"><Check size={14} className="text-[#C4A265]" /></div><span className="font-body text-[#4A4A4A]">{f}</span></div>))}</div>
                <h2 className="text-2xl text-[#0A0A0A] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Gallery</h2>
                <div className="grid grid-cols-4 gap-4">{imgs.map((img, i) => (<button key={i} onClick={() => setCi(i)} className={`relative h-24 overflow-hidden ${ci === i ? "ring-2 ring-[#0A4F3B]" : ""}`}><img src={img} alt={`Gallery ${i + 1}`} className="w-full h-full object-cover" /></button>))}</div>
              </div>
              <div className="lg:col-span-1">
                <div className="bg-[#FAFAFA] p-8 sticky top-32">
                  <h3 className="text-2xl text-[#0A0A0A] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Project Specifications</h3>
                  <div className="space-y-4 mb-8">{Object.entries(project.specs).map(([k, v]) => (<div key={k} className="flex justify-between border-b border-[rgba(0,0,0,0.05)] pb-4"><span className="font-body text-[#4A4A4A] capitalize">{k}</span><span className="font-body font-medium text-[#0A0A0A]">{v}</span></div>))}</div>
                  <div className="mb-8"><span className="font-body text-sm text-[#4A4A4A] uppercase tracking-wider">Price</span><div className="text-3xl text-[#C4A265] mt-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{project.price}</div></div>
                  {project.price !== "Sold Out" && (
                    <>
                      {project.price !== "Sold Out" && (
                        <>
                          <button
                            type="button"
                            onClick={() => setShowEnquiryModal(true)}
                            className="w-full inline-flex items-center justify-center gap-3 bg-[#0A4F3B] text-white px-8 py-4 text-sm tracking-[0.1em] uppercase hover:bg-[#1A6F53] transition-colors"
                          >
                            Enquire Now <ArrowRight size={16} />
                          </button>

                          <a
                            href="tel:+917529019797"
                            className="w-full mt-4 inline-flex items-center justify-center gap-3 border border-[#0A4F3B] text-[#0A4F3B] px-8 py-4 text-sm tracking-[0.1em] uppercase hover:bg-[#0A4F3B] hover:text-white transition-colors"
                          >
                            Call: +91 75290 19797
                          </a>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {showEnquiryModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
        onClick={() => setShowEnquiryModal(false)}>
          <div className="relative w-full max-w-2xl bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}>

            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b">
              <h2
                className="text-3xl text-[#0A0A0A]"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                Enquire Now
              </h2>

              <button
                onClick={() => setShowEnquiryModal(false)}
                className="text-2xl leading-none hover:text-red-500"
              >
                ×
              </button>
            </div>

            {/* Form */}
            <form onSubmit={sendMail} className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                <div>
                  <label className="block mb-2 text-sm font-medium">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={data.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#0A4F3B]"
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={data.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#0A4F3B]"
                  />
                </div>
                   <div>
                  <label className="block mb-2 text-sm font-medium">
                    Phone
                  </label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    required
                    value={data.phoneNumber}
                    onChange={handleChange}
                    className="w-full border border-gray-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#0A4F3B]"
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium">
                    City
                  </label>
                  <input
                    type="text"
                    name="city"
                    value={data.city}
                    onChange={handleChange}
                    className="w-full border border-gray-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#0A4F3B]"
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium">
                    Project
                  </label>
                  <input
                    type="text"
                    name="project"
                    value={data.project}
                    onChange={handleChange}
                    className="w-full border border-gray-300 px-4 py-3 rounded-md focus:outline-none focus:border-[#0A4F3B]"
                  />
                                    <div className="sm:col-span-2 mt-1">
                    <label className="text-[11px] uppercase tracking-[0.22em] font-bold text-navy-800">
                      Captcha *
                    </label>
                </div>


              </div>
                                 <div className="mt-3 flex items-center gap-3 flex-nowrap">
                      <input
                        type="text"
                        placeholder="Enter Captcha"
                        value={captchaInput}
                        onChange={(e) =>
                          setCaptchaInput(e.target.value)
                        }
                        className="w-[170px] max-sm:w-[150px] bg-transparent border-b-2 border-slate-200 focus:border-amber-500 outline-none py-2 text-navy-900 placeholder:text-slate-400 transition-colors"
                      />

                      <button
                        type="button"
                        onClick={() => {
                          setCaptchaText(generateCaptcha());
                          setCaptchaInput("");
                        }}
                        className="text-2xl text-navy-900 shrink-0"
                      >
                        ↻
                      </button>

                      <div className="text-[1.25rem] tracking-[0.25em] text-navy-900 font-semibold italic select-none whitespace-nowrap">
                        {captchaText}
                      </div>
                    </div>

                    {formError.captcha && (
                      <p className="text-red-500 text-xs mt-2">
                        {formError.captcha}
                      </p>
                    )}
                  </div>

              <div className="mt-5">
                <label className="block mb-2 text-sm font-medium">
                  Message
                </label>

                <textarea
                  rows="5"
                  name="message"
                  value={data.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 px-4 py-3 rounded-md resize-none focus:outline-none focus:border-[#0A4F3B]"
                />
              </div>

              <button
                type="submit"
                disabled={sending}
                className="mt-6 w-full bg-[#0A4F3B] text-white py-4 uppercase tracking-wider hover:bg-[#1A6F53] transition-colors"
              >
                  {sending ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};